export default __webpack_public_path__ + "static/media/candle-skull.ed9bbe05.jpg";